/*
  A little helper to check if the current environment is a mobile device. 
  Mostly useful to know if hover elements would not be accessible.
*/

export function isTouchDevice() {
  try {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  } catch (e) {
    return false;
  }
}
